import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

export interface OrdersFilterChipProps {
  label: string;
  onClear: () => void;
}

export function OrdersFilterChip({ label, onClear }: OrdersFilterChipProps) {
  const t = useTranslations();
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border py-1 ps-2.5 pe-1 text-[11.5px] font-medium"
      style={{
        background: "color-mix(in oklab, var(--accent-500) 10%, var(--card))",
        borderColor: "color-mix(in oklab, var(--accent-500) 25%, var(--card))",
        color: "var(--accent-600)",
      }}
    >
      {label}
      <button
        type="button"
        onClick={onClear}
        aria-label={t(keys.orders.removeFilter)}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-black/5 text-[color:var(--accent-600)]"
      >
        <svg
          width="9"
          height="9"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <path d="M6 6l12 12M6 18L18 6" />
        </svg>
      </button>
    </span>
  );
}
